import React from 'react';
import styled from 'styled-components';

import CTA from './CTA';

const Footer = styled.div`
  display: flex;
  padding: 20px;
  font-family: 'OCRoboto';
  background-color: black;
  @media (max-width: 1049px) {
    display: block;
  }
`;

const Info = styled.div`
  flex: 0.7;
  color: white;
  @media (max-width: 1049px) {
    margin: 15px;
  }
`;

export default ({ footerText, downloadURL }) => (
  <Footer>
    <Info>
      <p>{footerText}</p>
    </Info>
    <CTA downloadURL={downloadURL} />
  </Footer>
);
